import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";
import "./ebook.m.css";

export const Ebook = ({ element }) => {
  return (
    <div className="story-element story-element-ebook">
      {element["story-elements"].map(({ metadata, id }) => {
        const { description, url } = metadata;
        const name = metadata.name || "Click here";
        return (
          <div key={id} styleName="ebook">
            <div styleName="description">{description}</div>
            <div styleName="name-container">
              <Link href={url}>
                <div styleName="name">{name}</div>
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

Ebook.propTypes = {
  element: object,
};
